import script from "./AITrafficStats.vue?vue&type=script&setup=true&lang=js"
export * from "./AITrafficStats.vue?vue&type=script&setup=true&lang=js"

import "./AITrafficStats.vue?vue&type=style&index=0&id=3de0e6ac&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de0e6ac"]])

export default __exports__